// plan-02 S04: wire-mesh pass — 56px grid, OffscreenCanvas cached — bible S13B

import type { DrawPass } from '../canvas'

const SPACING = 56
const COLOR = 'rgba(10, 26, 10, 0.05)'

export function createWireMesh(): DrawPass {
  let cached: OffscreenCanvas | null = null
  let cachedW = 0
  let cachedH = 0

  function build(w: number, h: number): OffscreenCanvas {
    const oc = new OffscreenCanvas(w, h)
    const c = oc.getContext('2d')!
    c.strokeStyle = COLOR
    c.lineWidth = 1
    for (let x = SPACING; x < w; x += SPACING) {
      c.beginPath()
      c.moveTo(x, 0)
      c.lineTo(x, h)
      c.stroke()
    }
    for (let y = SPACING; y < h; y += SPACING) {
      c.beginPath()
      c.moveTo(0, y)
      c.lineTo(w, y)
      c.stroke()
    }
    return oc
  }

  return (ctx, w, h, _t): void => {
    if (!cached || cachedW !== w || cachedH !== h) {
      cached = build(w, h)
      cachedW = w
      cachedH = h
    }
    ctx.drawImage(cached, 0, 0)
  }
}
